var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.134,
    height: 15.124,
    viewBox: "0 0 21.134 15.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,3.8H4.491A2.011,2.011,0,0,0,2.5,5.825l-.01,9.957a2.018,2.018,0,0,0,2,2.022H20.5a2.018,2.018,0,0,0,2-2.022V5.825A2.016,2.016,0,0,0,20.5,3.8ZM3.635,4.462,12.8,12.884l9.168-8.422M3.232,17.156,10.75,11m4.5-.25L21.9,17.2",
    transform: "translate(-1.928 -3.242)",
    fill: "none",
    stroke: "#3393b9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.124
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.411cadc06108b2b72a349b2ddcde9e63.svg";
export { ForwardRef as ReactComponent };